<template>
    
    <div>    
       <!--  <p>Id ES {{$route.params.id}}</p> -->
        <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
                <li class="breadcrumb-item"><a>
                    <router-link :to="{name:'r-/'}">Inicio</router-link>
                </a></li>
                <li class="breadcrumb-item active" aria-current="page">Inventarios</li>
                <li class="breadcrumb-item active li-actualizar-datos" aria-current="page" title="Actualizar datos de inventario" v-if="general.otros.app_modo=='online'" @click=data_table>
                    <i class="fa fa-refresh" aria-hidden="true"></i>
                </li>
            </ol>
        </nav>
        <div>
            <div class="row">
                <div class="col-12 mt-4">
                    <div class="card">
                        <div class="card-body">
                            <!---<div class="form-row">
                                <div class="form-group col-md-3">
                                    <label for="inputEmail4" style="color:white;">Tipo:</label> 
                                    <select class="form-control input-3d" v-model=datos.tipo_inventario>
                                        <option value="inventario_actual">Inventario compras</option>
                                        <option value="rango_fecha">Compras por rango de fecha</option>
                                        <option value="inventario_bodega">Inventario bodega</option>
                                    </select>
                                </div>
                                <template v-if="datos.tipo_inventario=='rango_fecha'">
                                    <div class="form-group col-md-2">
                                        <label for="inputEmail4" style="color:white;">Fecha inicial:</label>   
                                        <input type="date" class="form-control input-3d" v-model=datos.fecha_inicial>
                                    </div>
                                    <div class="form-group col-md-3"></div>
                                    <div class="form-group col-md-2">
                                        <label for="inputEmail4" style="color:white;">Fecha final:</label>   
                                        <input type="date" class="form-control input-3d" v-model=datos.fecha_final>
                                    </div>
                                </template>                               
                                <div class="form-group col-md-2">
                                    <button class="boton-3d-success" type="button" @click="buscar_inventario">
                                        Buscar
                                    </button>
                                </div>
                            </div>-->
                            
                            <div class="form-row" v-if="datos.tipo_inventario=='inventario_bodega'">
                                <div class="col-md-4"></div>
                                <div class="form-group col-md-4">
                                    <a class="boton-3d-info" target="_blanck" :href="general.otros.dominio+'/#/inventarios_listos/informe'">
                                        Imprimir informe
                                    </a>
                                </div>
                                <div class="col-md-4"></div>
                            </div>


                            <div v-if="datos.data_table.cargando" class="d-flex justify-content-center" style="width:100%; margin-top:1em; margin-bottom:1em; color:white;">
                                <div class="spinner-border" role="status">
                                    <span class="sr-only">Loading...</span>
                                </div>
                            </div>     
                            <div id="contenedor-tabla-registros" style="width: 100%;">
                                
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>




        <!-- inicio modal registro -->
        <div class="modal fade bd-example-modal-lg" id="modal_traslado">
            <div class="modal-dialog modal-xl" style="width:90%;">
                <div class="modal-content modal-3d">
                    <div class="modal-header">                        
                        <h5 class="modal-title">
                            Trasladar {{ datos.registro.nombre }}  
                            a bodega
                        </h5>
                        <button type="button" class="close" data-dismiss="modal"><span>&times;</span></button>
                    </div>
                    <div class="modal-body">
                        <div>
                            <div v-if="datos.registro_cargando" class="d-flex justify-content-center" style="width:100%; margin-top:1em; margin-bottom:1em; color:black;">
                                <div class="spinner-border" role="status">
                                    <span class="sr-only">Loading...</span>
                                </div>
                            </div>
                            <div class="form-row">

                                <div class="form-group col-md-12">
                                    <label for="inputEmail4">Existencia disponible :</label>
                                    <p style="margin:0px; font-size:1.5em;">{{ datos.registro.existencia }} Kg</p>
                                </div>
                                <div class="form-group col-md-4">
                                    <label for="inputEmail4">¿ Cuanto va a trasladar (Kg) ?:</label>
                                    <input type="text" class="form-control input-3d" v-model=datos.registro.traslado_cantidad_total>
                                </div>
                                <div class="form-group col-md-8"></div>
                                <div class="form-group col-md-12">
                                    <!---<label for="inputEmail4">Productos relacionados:</label>-->
                                    <div>
                                        <template v-for='(pr,pr_index) in datos.registro.productos_relacionados' :key=pr_index>
                                            <div class="form-row contenedor-producto">

                                                <div class="form-group col-md-12" style="margin:0px;">

                                                    <div class="form-row">  
                                                        <div class="form-group col-md-3 col-12">
                                                            <label for="inputEmail4">Material:</label>
                                                            <p style="color:white;">{{ pr.productos_nombre }}</p>
                                                        </div>
                                                        <div class="form-group col-md-3 col-12">
                                                            <label for="inputEmail4">Cantidad (Kg) a trasladar:</label>
                                                            <input type="number" class="form-control input-3d" v-model=pr.cantidad>
                                                        </div>
                                                    </div>
                                                    
                                                </div>

                                            </div>
                                        </template>
                                    </div>

                                </div>                                                                                                                       
                                
                            </div>                          
                        </div>
                    </div>
                    <div class="modal-footer"  v-if="!datos.registro_cargando">

                        
                        <button type="button" class="boton-3d-success" @click=enviar_datos>
                            Trasladar ahora
                        </button>
                        <button type="button" class="boton-3d-danger" data-dismiss="modal">
                            Cerrar
                        </button>

                    </div>
                </div>
            </div>
        </div>
        <!---fin modal registro---->        


    </div>

</template>

<script>
/* eslint-disable */
import { mapActions, mapState, mapMutations, mapGetters } from 'vuex'
//import { mapMutations } from 'vuex'

import * as calculos  from '@/librerias/lobato-calculos.js'

export default {
    name: 'com_general',
    props: {
        msg: String
    },
    data() {
    return {
        datos:{
            registro_cargando:false,
            registro:{
                id:'',
                productos_relacionados:[],
                nombre:'',
                lleva_relacion:'',
                traslado_cantidad_total:'',
                existencia:''
                //clientes_id:'',
                //productos:[],
                //total_venta:'',
                //estado:''          
            },
            productos:{
                todos:[]
            },
            clientes:{
                todos:[]
            },
            data_table:{
                cargando:false,
                registros:[]
            },
            tipo_inventario:'',
            fecha_inicial:'',
            fecha_final:'',            
        }
    }
    },
    mounted(){
        this.inicial();
    },
    methods:{
        ...mapMutations(['funciones','alerta']),  
        //...mapActions(['formato_moneda']),
        inicial()
        {
            if(this.general.otros.autenticado===true)
            {
                //this.obtener_recursos();
                this.data_table();
            }
            else if(this.general.otros.autenticado===false)
            {
                this.$router.push('/login');
            }
        },  
        obtener_recursos()
        {
            fetch(`${this.general.otros.dominio_server}/compras/recursos`,{
                method:'GET',
                //body:JSON.stringify( this.datos.registro ),
                headers:{
                    'Accept'        :'application/json',
                    'Content-Type'  :'application/json',
                    //'Authorization' :`Bearer ${this.general.otros.token}`
                    //'X-CSRF-TOKEN':this.general.otros.csrf
                },
                credentials: 'include',                   
            })
            .then(res=>res.json())
            .then(respuesta=>{
                
                console.log('recursos');
                console.log(respuesta);
                this.datos.productos.todos  =respuesta.datos.productos;
                this.datos.clientes.todos   =respuesta.datos.clientes;

            })
            .catch(error=>{
                this.funciones({nombre:'alerta',estatus:'error',mensaje:`No pudo obtenerse los recursos`});
            })
            .finally( () => {
                //this.datos.data_table.cargando=false;                
            });
        },    
        boton_modal_registro()
        {
            for (const p in this.datos.registro) {                    
                
                if(p=='productos')
                {
                    this.datos.registro[p]=[];
                }
                else
                {
                    this.datos.registro[p]='';
                }
                
            }            

            this.funciones({nombre:'sonido',sonido:this.general.sonidos.abrir});
            $("#modal-registro").modal("show");
        },
        data_table()
        {
            this.datos.data_table.cargando=true;            
            fetch(`${this.general.otros.dominio_server}/inventarios/todos`,{
                //method:'GET',
                method:'POST',
                body:JSON.stringify( {
                    tipo_inventario :'inventario_actual',//this.datos.tipo_inventario,
                    fecha_inicial   :this.datos.fecha_inicial,
                    fecha_final     :this.datos.fecha_final
                } ),
                headers:{
                    'Accept'        :'application/json',
                    'Content-Type'  :'application/json',
                    //'Authorization' :`Bearer ${this.general.otros.token}`
                    //'X-CSRF-TOKEN':this.general.otros.csrf
                },
                credentials: 'include',                   
            })
            .then(res=>res.json())
            .then(respuesta=>{
                
                //this.datos.data_table.registros=respuesta.datos.productos; 
                if(respuesta.datos.tipo_inventario=='inventario_actual')
                {
                    let c=respuesta.datos.categorias;
                    let p=respuesta.datos.productos;

                    let categorias=[];
                    c.forEach((item)=>{
                        //this.datos.data
                        //item.id
                        let total_categoria=0;
                        let total_categoria_inversion_acumulada=0;
                        let cat_pro=p.filter((e)=>e.categorias_id===item.id);

                        cat_pro.forEach((item2)=>{
                            total_categoria=calculos.calcular_suma([
                                total_categoria,
                                item2.existencia
                            ]);

                            total_categoria_inversion_acumulada=calculos.calcular_suma([
                                total_categoria_inversion_acumulada,
                                item2.inversion_acumulada
                            ]);
                        });

                        categorias.push({
                            index           :categorias.length,
                            categoria_nombre:item.nombre,
                            producto        :'',
                            existencia      :total_categoria,
                            inversion_acumulada:total_categoria_inversion_acumulada,
                            cantidad_monetaria:'',
                            boton_traslado      :false
                        });
                        cat_pro.forEach((item2)=>{
                            categorias.push({
                                index               :categorias.length,
                                categoria_nombre    :'',
                                id                  :item2.id,
                                producto            :item2.nombre,
                                existencia          :item2.existencia,
                                inversion_acumulada :item2.inversion_acumulada,
                                cantidad_monetaria  :'',
                                lleva_relacion      :item2.lleva_relacion,
                                boton_traslado      :true
                            });
                        });
                        categorias.push({
                            index               :categorias.length,
                            categoria_nombre    :'',
                            producto            :'',
                            existencia          :'espacio',
                            inversion_acumulada :'',
                            cantidad_monetaria  :'',
                            boton_traslado      :false
                        });
                        
                    });
                    console.log('categorias');
                    console.log(categorias);
                    this.datos.data_table.registros=categorias;
                    
                    this.data_table_crear();
                }
                else if(respuesta.datos.tipo_inventario=='rango_fecha')
                {
                    let c=respuesta.datos.categorias;
                    let p=respuesta.datos.productos;

                    let categorias=[];
                    c.forEach((item)=>{
                        //this.datos.data
                        //item.id
                        let total_categoria=0;
                        let total_categoria_monetaria=0;
                        let cat_pro=p.filter((e)=>e.categorias_id===item.id);

                        cat_pro.forEach((item2)=>{

                            total_categoria=calculos.calcular_suma([
                                total_categoria,
                                //item2.existencia
                                item2.cantidad_kg
                            ]);

                            total_categoria_monetaria=calculos.calcular_suma([
                                total_categoria_monetaria,
                                item2.cantidad_monetaria
                            ]);

                        });

                        categorias.push({
                            index               :categorias.length,
                            categoria_nombre    :item.nombre,
                            producto            :'',
                            existencia          :total_categoria,
                            inversion_acumulada :'',
                            cantidad_monetaria  :total_categoria_monetaria,
                            boton_traslado      :false
                        });

                        cat_pro.forEach((item2)=>{
                            categorias.push({
                                index           :categorias.length,
                                categoria_nombre:'',
                                producto        :item2.nombre,
                                //existencia      :item2.existencia
                                existencia      :item2.cantidad_kg,
                                inversion_acumulada:'',
                                cantidad_monetaria  :item2.cantidad_monetaria,
                                boton_traslado      :false
                            });
                        });
                        categorias.push({
                            index           :categorias.length,
                            categoria_nombre:'',
                            producto        :'',
                            existencia      :'espacio',
                            inversion_acumulada:'',
                            cantidad_monetaria:'',
                            boton_traslado      :false
                        });
                        
                    });
                    console.log('categorias');
                    console.log(categorias);
                    this.datos.data_table.registros=categorias;
                    
                    this.data_table_crear();
                }
                else if(respuesta.datos.tipo_inventario=='inventario_bodega')
                {
                    let c=respuesta.datos.categorias;
                    let p=respuesta.datos.productos;

                    let categorias=[];
                    c.forEach((item)=>{
                        //this.datos.data
                        //item.id
                        let total_categoria=0;
                        let total_categoria_inversion_acumulada=0;
                        let cat_pro=p.filter((e)=>e.categorias_id===item.id);

                        cat_pro.forEach((item2)=>{

                            total_categoria=calculos.calcular_suma([
                                total_categoria,
                                item2.existencia
                            ]);

                            total_categoria_inversion_acumulada=calculos.calcular_suma([
                                total_categoria_inversion_acumulada,
                                item2.inversion_acumulada
                            ]);

                        });

                        categorias.push({
                            index           :categorias.length,
                            categoria_nombre:item.nombre,
                            producto        :'',
                            existencia      :total_categoria,
                            inversion_acumulada:total_categoria_inversion_acumulada,
                            //cantidad_monetaria:'',
                            //boton_traslado      :false
                        });
                        cat_pro.forEach((item2)=>{
                            categorias.push({
                                index               :categorias.length,
                                categoria_nombre    :'',
                                id                  :item2.id,
                                producto            :item2.nombre,
                                existencia          :item2.existencia,
                                inversion_acumulada :item2.inversion_acumulada,
                                //cantidad_monetaria  :'',
                                //lleva_relacion      :item2.lleva_relacion,
                                //boton_traslado      :true
                            });
                        });
                        categorias.push({
                            index               :categorias.length,
                            categoria_nombre    :'',
                            producto            :'',
                            existencia          :'espacio',
                            inversion_acumulada :'espacio',
                            //cantidad_monetaria  :'',
                            //boton_traslado      :false
                        });
                        
                    });
                    console.log('categorias');
                    console.log(categorias);
                    this.datos.data_table.registros=categorias;
                    
                    this.data_table_inventario_bodega_crear();
                }

            })
            .catch(error=>{
                //this.funciones({nombre:'alerta',estatus:'error',mensaje:`No pudo obtenerse los clientes`});
            })
            .finally( () => {
                this.datos.data_table.cargando=false;                
            });
        },
        data_table_inventario_bodega_crear()
        {
            document.getElementById('contenedor-tabla-registros').innerHTML=`
                <table id="tabla-registros" class="table table-hover w-100 pb-30">
                    <thead>
                        <tr>
                            <th>I</th>
                            <th>Categoria</th>
                            <th>Material</th>
                            <th>Existencia (Kg)</th>
                            <th>Inversión acumulada</th>
                        </tr>
                    </thead>
                    <tbody>
                    </tbody>
                    <tfoot>
                        <tr>
                            <th>I</th>
                            <th>Categoria</th>
                            <th>Material</th>
                            <th>Existencia (Kg)</th>
                            <th>Inversión acumulada</th>
                        </tr>
                    </tfoot>
                </table>
            `;
            $('#tabla-registros thead tr').clone(true).appendTo( '#tabla-registros thead' );
            $('#tabla-registros thead tr:eq(1) th').each( function (i) {
                var title = $(this).text();
                $(this).html( '<input class="form-control" style="width:100%;font-size:11px;" type="text" placeholder="Buscar '+title+'" />' );
        
                $( 'input', this ).on( 'keyup change', function () {
                    if ( tabla_registros.column(i).search() !== this.value ) {
                        tabla_registros
                            .column(i)
                            .search( this.value )
                            .draw();
                    }
                } );
            } );
            
            var tabla_registros=$('#tabla-registros').DataTable({
                orderCellsTop: true,
                fixedHeader: true,
                responsive: true,
                autoWidth: true,
                "order":[0,'asc'],
                lengthMenu:[5,10,25,50,100],
                pageLength:100,
                language: {
                    search: "Buscar",
                    searchPlaceholder: "Buscar",
                    lengthMenu: "Mostrando _MENU_ registros por página",
                    zeroRecords: "No se encontraron registros",
                    info: "Mostrando pagina _PAGE_ de _PAGES_",
                    infoEmpty: "No hay registros disponibles",
                    infoFiltered: "(filtrando de _MAX_ registros)",
                    paginate: {
                        "first":      "First",
                        "last":       "Last",
                        next:       "Siguiente",
                        previous:   "Anterior"
                    },
                },
                //ajax:`/ordenes_elaboracion_materiales/todos`,
                //ajax:`/clientes/todos`,
                data:this.datos.data_table.registros,                
                columnDefs:[
                    {"targets":0, visible:false, "data":function(data,type,full,meta)
                        {
                            return data.index;
                        }
                    }, 
                    {"targets":1, "data":function(data,type,full,meta)
                        {                            
                            return `
                                <p style="font-size: 1.5em; font-weight: bold;">
                                    ${data.categoria_nombre}
                                </p>
                            `;
                        }
                    }, 
                    {"targets":2, "data":function(data,type,full,meta)
                        {
                            return data.producto;
                        }
                    }, 
                    {"targets":3, "data":(data,type,full,meta)=>
                        {
                            if(data.existencia==='espacio')
                            {
                                return '';
                            }
                            else
                            {
                                if(data.categoria_nombre=='')
                                {
                                    return this.formato_numerico(data.existencia);
                                }
                                else
                                {
                                    return `
                                        <p style="font-size: 1.5em; font-weight: bold;">
                                            ${this.formato_numerico(data.existencia)}
                                        </p>
                                    `;                       
                                }
                            }
                        }                        
                    },
                    {"targets":4, "data":(data,type,full,meta)=>
                        {
                            if(data.existencia==='espacio')
                            {
                                return '';
                            }
                            else
                            {
                                if(data.categoria_nombre=='')
                                {
                                    return this.formato_moneda(data.inversion_acumulada);
                                }
                                else
                                {
                                    return `
                                        <p style="font-size: 1.5em; font-weight: bold;">
                                            ${this.formato_moneda(data.inversion_acumulada)}
                                        </p>
                                    `;                       
                                }
                            }
                        }                        
                    }
                ],
                //"drawCallback": this.eventos_data_table
            });
            tabla_registros.on( 'responsive-display',  ( e, datatable, row, showHide, update ) => {               
                //this.eventos_data_table();
            } );
        },
        data_table_crear()
        {
            document.getElementById('contenedor-tabla-registros').innerHTML=`
                <table id="tabla-registros" class="table table-hover w-100 pb-30">
                    <thead>
                        <tr>
                            <th>I</th>
                            <th>Categoria</th>
                            <th>Material</th>
                            <th>Existencia (Kg)</th>
                            <th>Cantidad monetaria</th>
                            <th>Inversión acumulada</th>
                            <th>Acciones</th>
                        </tr>
                    </thead>
                    <tbody >
                    </tbody>
                    <tfoot>
                        <tr>
                            <th>I</th>
                            <th>Categoria</th>
                            <th>Material</th>
                            <th>Existencia (Kg)</th>
                            <th>Cantidad monetaria</th>
                            <th>Inversión acumulada</th>
                            <th>Acciones</th>
                        </tr>
                    </tfoot>
                </table>
            `;
            $('#tabla-registros thead tr').clone(true).appendTo( '#tabla-registros thead' );
            $('#tabla-registros thead tr:eq(1) th').each( function (i) {
                var title = $(this).text();
                $(this).html( '<input class="form-control" style="width:100%;font-size:11px;" type="text" placeholder="Buscar '+title+'" />' );
        
                $( 'input', this ).on( 'keyup change', function () {
                    if ( tabla_registros.column(i).search() !== this.value ) {
                        tabla_registros
                            .column(i)
                            .search( this.value )
                            .draw();
                    }
                } );
            } );
            
            var tabla_registros=$('#tabla-registros').DataTable({
                orderCellsTop: true,
                fixedHeader: true,
                responsive: true,
                autoWidth: true,
                "order":[0,'asc'],
                lengthMenu:[5,10,25,50,100],
                pageLength:100,
                language: {
                    search: "Buscar",
                    searchPlaceholder: "Buscar",
                    lengthMenu: "Mostrando _MENU_ registros por página",
                    zeroRecords: "No se encontraron registros",
                    info: "Mostrando pagina _PAGE_ de _PAGES_",
                    infoEmpty: "No hay registros disponibles",
                    infoFiltered: "(filtrando de _MAX_ registros)",
                    paginate: {
                        "first":      "First",
                        "last":       "Last",
                        next:       "Siguiente",
                        previous:   "Anterior"
                    },
                },
                //ajax:`/ordenes_elaboracion_materiales/todos`,
                //ajax:`/clientes/todos`,
                data:this.datos.data_table.registros,                
                columnDefs:[
                    {"targets":0, visible:false, "data":function(data,type,full,meta)
                        {
                            return data.index;
                        }
                    }, 
                    {"targets":1, "data":function(data,type,full,meta)
                        {
                            //font-size: 1.5em;
                            //font-weight: bold;
                            
                            //let p='';
                            //return data.categoria_nombre;
                            return `
                                <p style="font-size: 1.5em; font-weight: bold;">${data.categoria_nombre}</p>
                            `;
                        }
                    }, 
                    {"targets":2, "data":function(data,type,full,meta)
                        {
                            return data.producto;
                        }
                    }, 
                    {"targets":3, "data":(data,type,full,meta)=>
                        {
                            if(data.existencia==='espacio')
                            {
                                return '';
                            }
                            else
                            {
                                if(data.categoria_nombre=='')
                                {
                                    return this.formato_numerico(data.existencia);
                                }
                                else
                                {
                                    return `
                                        <p style="font-size: 1.5em; font-weight: bold;">
                                            ${this.formato_numerico(data.existencia)}
                                        </p>
                                    `;                       
                                }
                            }
                        }                        
                    },
                    {
                        "targets":4, 
                        //visible:this.datos.tipo_inventario=='rango_fecha' ? true : false, 
                        visible:this.general.verificacion_rol.inventario.col_can_mon && this.datos.tipo_inventario=='rango_fecha' ? true : false, 
                        "data":(data,type,full,meta)=>
                        {
                            let c=[null,''].includes(data.cantidad_monetaria) ? '' : this.formato_moneda(data.cantidad_monetaria);
                            return c;
                        }
                    },
                    {
                        "targets":5, 
                        //visible:this.datos.tipo_inventario=='inventario_actual' ? true : false, 
                        //visible:this.general.verificacion_rol.inventario.col_inv_acu && this.datos.tipo_inventario=='inventario_actual' ? true : false,
                        visible:false,
                        "data":(data,type,full,meta)=>
                        {
                            let c=[null,''].includes(data.inversion_acumulada) ? '' : this.formato_moneda(data.inversion_acumulada);
                            return c;
                        }
                    },
                    {
                        "targets":6, 
                        //visible:this.datos.tipo_inventario=='inventario_actual' ? true : false, 
                        //visible:this.datos.tipo_inventario=='inventario_actual' ? true : false,
                        visible:false,
                        "data":(data,type,full,meta)=>
                        {
                            if( data.boton_traslado )
                            {
                                let a='';                                
                                a+=`
                                    <button registro-id='${data.id}' class='boton-3d-info boton_modal_traslado'>
                                        <i registro-id='${data.id}' class="fa fa-random" aria-hidden="true"></i>
                                    </button>
                                `;
                                return a;

                            }
                            else
                            {
                                return '';
                            }

                        }
                    }
                ],
                "drawCallback": this.eventos_data_table
            });
            tabla_registros.on( 'responsive-display',  ( e, datatable, row, showHide, update ) => {               
                this.eventos_data_table();
            } );
            
        },
        eventos_data_table()
        {
            Array.from(document.getElementsByClassName("boton_modal_traslado")).forEach((item)=>{
                item.addEventListener('click',this.boton_modal_traslado);
            });
            
            /* Array.from(document.getElementsByClassName("boton-modal-eliminar")).forEach((item)=>{
                item.addEventListener('click',this.boton_modal_eliminar);
            }); */
        },
        boton_modal_traslado(item)
        {
            let r=this.datos.registro;

            r.id=calculos.atributo(item,'registro-id');
            r.productos_relacionados=[];
            r.nombre='';
            r.traslado_cantidad_total='';
            r.lleva_relacion='';
            r.existencia='';

            this.datos.registro_cargando=true;
            $("#modal_traslado").modal('show');
            fetch(`${this.general.otros.dominio_server}/inventarios/productos/${r.id}/relacionados`,{
                method:'get',                
                headers:{                    
                    //'Content-Type':'application/json',
                    //'X-CSRF-TOKEN':this.general.otros.csrf
                    'Content-Type'  :'application/json',
                    'Accept'        :'application/json',
                    //'Authorization' :`Bearer ${this.general.otros.token}`
                },
                credentials: 'include',                   
            })
            .then(res=>res.json())
            .then(respuesta=>{

                console.log('relacionados');
                console.log(respuesta);

                let v=respuesta.datos.vinculados;
                let p=respuesta.datos.producto;
                let pr=[];                

                r.nombre            =p.length>0 ? p[0].nombre : '';
                r.lleva_relacion    =p.length>0 ? p[0].lleva_relacion : '';

                r.existencia        =p.length>0 ? p[0].existencia : '';
                r.existencia        =this.formato_numerico(r.existencia);

                if(r.lleva_relacion=='si')
                {
                    v.forEach((item,index)=>{
                        pr.push({
                            productos_id    :item.productos_id,
                            productos_nombre:item.productos_nombre,
                            cantidad        :''
                        });
                    });                                    
                }
                else
                {
                    pr.push({
                        productos_id    :r.id,
                        productos_nombre:r.nombre,
                        cantidad        :''
                    });
                }
                r.productos_relacionados=pr;


            })
            .catch(error=>{

            })
            .finally( () => {
                this.datos.registro_cargando=false;
            });
        },
        boton_modal_editar_registro_evento(item)
        {        
            this.boton_modal_registro();
            this.datos.registro.id=item.target.getAttribute('registro-id');  
            this.datos.registro_cargando=true;          
            //fetch(`${this.general.otros.dominio}/productos/${this.datos.registro.id}/datos`)
            fetch(`${this.general.otros.dominio_server}/ventas/${this.datos.registro.id}/datos`,{
                method:'get',                
                headers:{                    
                    //'Content-Type':'application/json',
                    //'X-CSRF-TOKEN':this.general.otros.csrf
                    'Content-Type'  :'application/json',
                    'Accept'        :'application/json',
                    //'Authorization' :`Bearer ${this.general.otros.token}`
                },
                credentials: 'include',                   
            })
            .then(res=>res.json())
            .then(respuesta=>{

                let r=respuesta.datos.venta[0];

                this.datos.registro.clientes_id =r.clientes_id;
                this.datos.registro.total_venta =r.total_venta;
                this.datos.registro.estado      =r.estado;

                r.productos.forEach((item,index)=>{
                    this.agregar_producto(item);
                });

            })
            .catch(error=>{

            })
            .finally( () => {
                this.datos.registro_cargando=false;
            });
            
        },                
        agregar_producto(p)
        {
            this.funciones({nombre:'sonido',sonido:this.general.sonidos.agregar});
            this.datos.registro.productos.push({
                id          :p==='' ? '' : p.id,
                productos_id:p==='' ? '' : p.productos_id,
                precio      :p==='' ? '' : p.precio,
                cantidad    :p==='' ? '' : p.cantidad,
                total       :p==='' ? '' : p.total,
                posicion    :'',
                estado      :'activo'
            });
            this.productos_ordenar_posiciones();
        },
        boton_remover_producto(index)
        {
            this.funciones({nombre:'sonido',sonido:this.general.sonidos.remover});
            this.datos.registro.productos[index].estado='inactivo';
            this.productos_ordenar_posiciones();
            this.calcular_registro_venta_total();
        },
        productos_ordenar_posiciones()
        {            
            let a=0;
            this.datos.registro.productos.forEach((item,index)=>{
                
                if(item.estado=='activo')
                {
                    a++;
                    item.posicion=a;
                }

            });
        },

        ////////////////
        material_seleccionado(index)
        {
            /* let p=this.datos.registro.productos[index];
            let a=(this.datos.productos.todos).find((e)=>e.id==p.productos_id);
            p.precio=a===undefined ? 0 : a.precio;
            this.calcular_producto_total(index); */
        },
        calcular_producto_total(index)
        {
            let p=this.datos.registro.productos[index];
            p.total=calculos.calcular_multiplicacion([
                p.precio,
                p.cantidad
            ]);
            p.total=(p.total).toFixed(2);
            this.calcular_registro_venta_total();
        },
        calcular_registro_venta_total()
        {
            let r=this.datos.registro;
            r.total_venta=0;

            (r.productos).forEach((p,index)=>{

                if(p.estado=='activo')
                {                                    
                    r.total_venta=calculos.calcular_suma([
                        r.total_venta,
                        p.total
                    ]);
                }
            });
            console.log(this.datos.registro);
        },
        enviar_datos(a)
        {
            this.alerta({titulo:'Procesando datos',mensaje:'espere ...'});  
                        
            let pr=(this.datos.registro.productos_relacionados).filter( (e)=> calculos.revisar_numero(e.cantidad)>0 );            

            let c=0;
            pr.forEach((item,index)=>{
                c=calculos.calcular_suma([
                    c,
                    item.cantidad
                ]);
            });

            this.datos.registro.traslado_cantidad_total=calculos.revisar_numero(this.datos.registro.traslado_cantidad_total);

            if(c<=this.datos.registro.traslado_cantidad_total)
            {
                let mer=calculos.calcular_resta([
                    this.datos.registro.traslado_cantidad_total,
                    c
                ]);
                    
                fetch(`${this.general.otros.dominio_server}/inventarios/productos/${this.datos.registro.id}/trasladar`,{
                    method:'POST',
                    body:JSON.stringify( {
                        traslado_cantidad_total:this.datos.registro.traslado_cantidad_total,
                        merma:mer,
                        productos:pr
                    } ),
                    headers:{                    
                        //'X-CSRF-TOKEN':this.general.otros.csrf
                        'Content-Type'  :'application/json',
                        'Accept'        :'application/json',
                        //'Authorization' :`Bearer ${this.general.otros.token}`
                    },
                    credentials: 'include',                   
                })
                //.then(res=>res.json())
                .then(res => {
                    if (res.status == 200) 
                    {
                        return res.json();
                    }
                    else
                    {
                        throw new Error(`Error: ${res.status}`);
                    }
                })
                .then(respuesta=>{
                    let dt={
                        'bien':()=>{                        
                            this.data_table();
                            $("#modal_traslado").modal("hide");
                            this.funciones({nombre:'alerta',estatus:'success',mensaje:`Traslado guardado`});
                        }
                    };

                    if(respuesta.mensaje in dt )
                    {
                        dt[respuesta.mensaje]();
                    }                
                })
                .catch(error=>{
                    this.funciones({nombre:'alerta',estatus:'error',mensaje:`El traslado no se pudo guardar`});
                    console.log('error es');
                    console.log(error);
                })
                .finally( () => {
                    //this.datos.data_table.cargando=false;
                });
            }
            else
            {
                this.funciones({nombre:'alerta',estatus:'error',mensaje:`El traslado total debe ser igual o mayor al de las filas azules`});
            }


        },
        formato_numerico(m)
        {
            m=calculos.revisar_numero(m);
            return (m).toLocaleString('es-MX',{ minimumFractionDigits: 3, maximumFractionDigits: 3});
            /* return (m).toLocaleString("es-MX",{
                style: 'currency',
                currency: 'MXN'
            }); */
        },
        buscar_inventario()
        {
            this.datos.data_table.registros=[];                    
            this.data_table_crear();
            this.data_table();
        },
        formato_moneda(m)
        {
            m=calculos.revisar_numero(m);
            return (m).toLocaleString("es-MX",{
                style: 'currency',
                currency: 'MXN'
            });
        }  
    },
    computed: {
        ...mapState(['general']),
        /* ...mapGetters(['formatear_moneda']),
        formato_moneda(m)
        {
            this.formatear_moneda(m);
        } */
    },
    watch: {
        'general.otros.autenticado': function (v) {
            if(v)
            {
                this.inicial();
            }
        }
    }
}
</script>

<style lang="scss" scoped>        
    .contenedor-producto{
        background:linear-gradient(90deg, #0093ff, #484848);
        border-radius:7px; 
        margin-bottom:1em; 
        padding:1em;
        box-shadow: 0 4px 6px rgba(0, 0, 0, 0.8);
        padding-bottom:0px; 
        padding-top:0.5em;

        /* &:hover{
            background:linear-gradient(90deg, #01253f, #1d1c1c);
        } */

        label {
            color:white;
        }
    }
    .custom-select{
        width:45px;
    }
    
</style>